const modeInitialState = {
    mode: {
        value: false
    }
}

export default modeInitialState